(function () {
  'use strict';

  /*
   * Löwenkind UI Tracking
   *
   * Zentrales Click-Tracking für Elemente mit:
   * data-lk-track="true"
   *
   * Veröffentlichung über:
   * Shopify.analytics.publish('lk:ui_click', ...)
   */

  const EVENT_NAME = 'lk:ui_click';

  /*
   * Debugging nur aktiv, wenn die URL enthält:
   * ?lk_tracking_debug=true
   *
   * Beispiel:
   * https://loewenkind.net/?lk_tracking_debug=true
   */
  const DEBUG =
    new URLSearchParams(window.location.search)
      .get('lk_tracking_debug') === 'true';


  /*
   * --------------------------------------------------
   * Debug Helpers
   * --------------------------------------------------
   */

  function debugLog() {
    if (!DEBUG) return;

    console.log.apply(
      console,
      ['[LK Tracking]'].concat(Array.from(arguments))
    );
  }


  function debugError() {
    if (!DEBUG) return;

    console.error.apply(
      console,
      ['[LK Tracking]'].concat(Array.from(arguments))
    );
  }


  /*
   * --------------------------------------------------
   * Werte bereinigen
   * --------------------------------------------------
   */

  function cleanValue(value, maxLength) {
    if (typeof value !== 'string') {
      return '';
    }

    const cleaned = value.trim();

    return cleaned.substring(
      0,
      maxLength || 200
    );
  }


  /*
   * --------------------------------------------------
   * Klicktext ermitteln
   * --------------------------------------------------
   *
   * Priorität:
   * 1. data-lk-text
   * 2. aria-label
   * 3. sichtbarer Text
   */

  function getClickText(element) {
    const customText =
      element.dataset.lkText;

    if (customText) {
      return cleanValue(
        customText,
        100
      );
    }


    const ariaLabel =
      element.getAttribute('aria-label');

    if (ariaLabel) {
      return cleanValue(
        ariaLabel,
        100
      );
    }


    return cleanValue(
      element.textContent || '',
      100
    );
  }


  /*
   * --------------------------------------------------
   * Ziel-URL ermitteln
   * --------------------------------------------------
   */

  function getClickUrl(element) {
    if (
      element.tagName &&
      element.tagName.toLowerCase() === 'a'
    ) {
      return cleanValue(
        element.href || '',
        500
      );
    }


    const parentLink =
      element.closest('a');

    if (parentLink) {
      return cleanValue(
        parentLink.href || '',
        500
      );
    }


    return '';
  }


  /*
   * --------------------------------------------------
   * Leere Werte entfernen
   * --------------------------------------------------
   */

  function removeEmptyValues(data) {
    const cleanedData = {};

    Object.keys(data).forEach(function (key) {
      const value = data[key];

      if (
        value !== '' &&
        value !== null &&
        typeof value !== 'undefined'
      ) {
        cleanedData[key] = value;
      }
    });

    return cleanedData;
  }


  /*
   * --------------------------------------------------
   * Event-Daten erzeugen
   * --------------------------------------------------
   */

  function buildEventData(element) {
    const sectionElement =
      element.closest('[data-section-id]');

    const data = {

      /*
       * Standardmäßig:
       * a
       * button
       * div
       *
       * Kann überschrieben werden mit:
       * data-lk-type="product_card"
       */
      click_type:
        cleanValue(
          element.dataset.lkType ||
          (
            element.tagName
              ? element.tagName.toLowerCase()
              : ''
          ),
          50
        ),

      click_area:
        cleanValue(
          element.dataset.lkArea,
          100
        ),

      click_element:
        cleanValue(
          element.dataset.lkElement,
          100
        ),

      click_position:
        cleanValue(
          element.dataset.lkPosition,
          100
        ),

      click_campaign:
        cleanValue(
          element.dataset.lkCampaign,
          100
        ),

      click_text:
        getClickText(element),

      click_url:
        getClickUrl(element),

      page_path:
        cleanValue(
          window.location.pathname,
          500
        ),

      /*
       * Nur fürs Debugging / technische Zuordnung.
       * Nicht zwingend als GA4 Custom Dimension verwenden.
       */
      section_id:
        cleanValue(
          sectionElement
            ? sectionElement.dataset.sectionId
            : '',
          100
        )

    };


    return removeEmptyValues(data);
  }


  /*
   * --------------------------------------------------
   * Shopify Event veröffentlichen
   * --------------------------------------------------
   */

  function publishEvent(element) {
    if (
      !window.Shopify ||
      !Shopify.analytics ||
      typeof Shopify.analytics.publish !== 'function'
    ) {
      debugError(
        'Shopify.analytics.publish ist nicht verfügbar.'
      );

      return;
    }


    const eventData =
      buildEventData(element);


    try {
      Shopify.analytics.publish(
        EVENT_NAME,
        eventData
      );


      debugLog(
        'Event published:',
        EVENT_NAME,
        eventData
      );

    } catch (error) {
      debugError(
        'Publish error:',
        error
      );
    }
  }


  /*
   * --------------------------------------------------
   * Globaler Click Listener
   * --------------------------------------------------
   *
   * Event Delegation:
   * Wir hängen nicht an jedes Element einzeln
   * einen Listener.
   *
   * Dadurch funktioniert das Tracking auch für
   * dynamisch eingefügte Elemente.
   */

  document.addEventListener(
    'click',
    function (event) {
      /*
       * Falls event.target einmal kein Element sein sollte,
       * brechen wir sicher ab.
       */
      if (
        !event.target ||
        typeof event.target.closest !== 'function'
      ) {
        return;
      }


      const trackingElement =
        event.target.closest(
          '[data-lk-track="true"]'
        );


      if (!trackingElement) {
        return;
      }


      publishEvent(
        trackingElement
      );
    }
  );


  debugLog(
    'Central tracking initialized.'
  );

})();